module.exports = __webpack_public_path__ + "static/media/ratings.ec4d002c.jpeg";